import './grid.scss';

const DRAG_START_PX = 6;

const initGridCarousel = ( root ) => {
	const viewport = root.querySelector( '.b-grid__viewport' );
	const track = root.querySelector( '.b-grid__track' );
	const prev = root.querySelector( '[data-grid-dir="prev"]' );
	const next = root.querySelector( '[data-grid-dir="next"]' );

	if ( ! viewport || ! track ) {
		return;
	}

	const items = Array.from( track.children );
	if ( items.length === 0 ) {
		return;
	}

	let index = 0;
	let pointerStartX = null;
	let pointerStartOffset = 0;
	let activePointerId = null;
	let dragged = false;
	let suppressClick = false;

	const itemWidth = () => items[ 0 ].getBoundingClientRect().width + parseFloat( getComputedStyle( track ).gap || '0' );
	const visibleCount = () => Math.max( 1, Math.floor( viewport.clientWidth / itemWidth() ) );
	const maxIndex = () => Math.max( 0, items.length - visibleCount() );
	const clamp = ( value ) => Math.min( Math.max( value, 0 ), maxIndex() );

	const updateNavigation = () => {
		const atStart = index <= 0;
		const atEnd = index >= maxIndex();
		if ( prev ) {
			prev.toggleAttribute( 'hidden', atStart );
			prev.setAttribute( 'aria-disabled', atStart ? 'true' : 'false' );
		}
		if ( next ) {
			next.toggleAttribute( 'hidden', atEnd );
			next.setAttribute( 'aria-disabled', atEnd ? 'true' : 'false' );
		}
	};

	const apply = ( animate = true ) => {
		index = clamp( index );
		track.style.transition = animate ? '' : 'none';
		track.style.transform = `translate3d(${ -index * itemWidth() }px, 0, 0)`;
		updateNavigation();
	};

	const go = ( delta ) => {
		index = clamp( index + delta );
		apply();
	};

	prev?.addEventListener( 'click', () => go( -1 ) );
	next?.addEventListener( 'click', () => go( 1 ) );

	const resizeObserver = new ResizeObserver( () => apply( false ) );
	resizeObserver.observe( viewport );

	viewport.addEventListener( 'pointerdown', ( event ) => {
		if ( event.pointerType === 'mouse' && event.button !== 0 ) return;
		pointerStartX = event.clientX;
		pointerStartOffset = -index * itemWidth();
		activePointerId = event.pointerId;
		dragged = false;
		track.style.transition = 'none';
	} );

	viewport.addEventListener( 'pointermove', ( event ) => {
		if ( pointerStartX === null || event.pointerId !== activePointerId ) return;
		const distance = event.clientX - pointerStartX;
		if ( ! dragged && Math.abs( distance ) <= DRAG_START_PX ) return;
		dragged = true;
		viewport.setPointerCapture?.( event.pointerId );
		track.style.transform = `translate3d(${ pointerStartOffset + distance }px, 0, 0)`;
	} );

	const endPointer = ( event ) => {
		if ( pointerStartX === null || event.pointerId !== activePointerId ) return;
		const distance = event.clientX - pointerStartX;
		pointerStartX = null;
		activePointerId = null;
		if ( dragged ) suppressClick = true;
		const threshold = itemWidth() * 0.2;
		if ( distance < -threshold ) index += 1;
		if ( distance > threshold ) index -= 1;
		apply();
	};

	viewport.addEventListener( 'pointerup', endPointer );
	viewport.addEventListener( 'pointercancel', endPointer );
	viewport.addEventListener( 'click', ( event ) => {
		if ( ! suppressClick ) return;
		suppressClick = false;
		event.preventDefault();
		event.stopPropagation();
	}, true );
	track.querySelectorAll( 'a, img' ).forEach( ( element ) => {
		element.addEventListener( 'dragstart', ( event ) => event.preventDefault() );
	} );

	apply( false );
};

document.querySelectorAll( '.b-grid--carousel' ).forEach( initGridCarousel );
